import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import { usePagination } from '~/composables';

interface Props {
  pagesCount?: number | null;
  currentPage?: number | string;
  marginPages?: number;
  pageRange?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiPagination',
  props: {
    pagesCount: { default: null },
    currentPage: { default: 1 },
    marginPages: { default: 1 },
    pageRange: { default: 3 }
  },
  setup(__props: any) {

const props = __props as { pagesCount: number | null, currentPage: number | string, marginPages: number, pageRange: number };



const route = useRoute();
const query = computed(() => route.value.query);
const { pagination } = usePagination({ ...props } as any);
const linkToPage = (page: any) => ({ query: { ...query.value, page } });

return { __sfc: true,props, route, query, pagination, linkToPage }
}

})